import {UI} from "../../../../stem-core/src/ui/UIBase";

import {WalletCard, WalletCardStyle} from "../../ui/WalletCard";
import {Messages} from "../../../Messages";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {WalletPopup} from "../../ui/WalletPopup";
import {UserPreferencesStore} from "../../../State";
import {Money} from "../../../../client/state/misc/Money";
import {WALLET_WELCOME_CONTENT_HEIGHT} from "../../WidgetConstants";
import {WalletStore} from "../../../State";
import {MessageElement} from "../../ui/MessageElement";
import {Router} from "../../../../stem-core/src/ui/Router.jsx";
import {BlinkButton} from "../../../ui/Button.jsx";


class ElementStyle extends WalletCardStyle {
    @styleRuleInherit
    content = {
        color: this.themeProps.WALLET_WELCOME_TEXT_COLOR,
        ">*": {
            marginBottom: 20,
        },
        height: WALLET_WELCOME_CONTENT_HEIGHT,
    };
}

@registerStyle(ElementStyle)
export class Element extends WalletCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.welcomeTitle,
        };
    }

    render() {
        const currency = WalletStore.getWallet().getCurrency();
        const preferences = UserPreferencesStore.getPreferences();

        return [
            <MessageElement message={Messages.welcomeText1(new Money(currency.getSettings().signupCredit, currency))} />,
            <MessageElement message={Messages.welcomeText2(new Money(preferences.articlePriceLimit, currency))} />,
        ];
    }

    renderPrimaryButton() {
        return <BlinkButton
            onClick={() => Router.back()}
            label={Messages.welcomeContinue}
        />
    }

    renderSecondaryButton() {
        return null;
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(UserPreferencesStore, () => this.redraw());
    }
}

export const Welcome = WalletPopup(Element);
